const KycStatus = {
    Pending_With_Bank: 0,
    Rejected_By_Bank: 1,
    Pending_With_Oxigen_KYC_Team: 2,
    Documents_Not_Submitted: 3,
    KYC_DONE: 4,
    MIN_KYC:5,
    AADHAR_BASED:6
}
export default KycStatus;